<template>
  <div v-show="modal" class="dialog">
    <div class="mask"></div>
    <div class="my-modal">
      <div class="title">
        {{ title }}
        <Icon
          type="md-close"
          class="btn"
          size="24"
          @click="$emit('close')"
        ></Icon>
      </div>
      <div class="content">
        <div class="head">{{ textHead }}</div>
        <div class="text-box">
          <div class="text" v-html="data"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SelectSchoolModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: String,
      default: ''
    }
  },
  emits: ['close'],
  data() {
    return {
      // 是否显示弹窗
      modal: false,
      title: '课程介绍预览',
      textHead: '课程介绍'
    };
  },
  watch: {
    visible(newVal) {
      this.modal = newVal;
    }
  }
};
</script>
<style lang="scss" scoped>
// 弹窗
.dialog {
  // 遮盖层
  .mask {
    position: fixed;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    z-index: 10000;
  }
  // 对话框
  .my-modal {
    position: fixed;
    width: 380px;
    height: 560px;
    background: rgb(247, 248, 250);
    // padding: 0 20px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 20000;
    // border-radius: 8px;
    box-shadow: 4px 4px 2px gray;
    .title {
      background: #fff;
      font-weight: 700;
      text-align: center;
      line-height: 44px;
      font-size: 16px;
      margin-bottom: 14px;
      .btn {
        float: right;
        margin-top: 10px;
        margin-right: 20px;
      }
    }
    .content {
      background: #fff;
      width: 100%;
      height: 500px;
      border-radius: 8px;
      padding: 10px 20px 0 20px;
      display: flex;
      flex-direction: column;
      .head {
        font-weight: 700;
        text-indent: 2px;
        margin-bottom: 10px;
        width: 100%;
        height: 30px;
      }
      .text-box {
        flex: 1;
        overflow-y: scroll;
        .text {
          font-size: 14px;
          min-height: 14px;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
